import { lazy } from 'react';
import { DISPUTE_PERMISSIONS } from './constants';

const DisputeListPage = lazy(() => import('./pages/DisputeListPage'));
const DisputeDetailPage = lazy(() => import('./pages/DisputeDetailPage'));

export const disputeRoutes = [
  {
    path: '/disputes',
    element: DisputeListPage,
    permission: DISPUTE_PERMISSIONS.MEDIATE,
    nav: { labelKey: 'nav.disputes', icon: 'WarningOutlined', group: 'operations' },
  },
  { path: '/disputes/:id', element: DisputeDetailPage, permission: DISPUTE_PERMISSIONS.MEDIATE, nav: null },
];
